export default __webpack_public_path__ + "static/media/negative-circle.0ce8234d.svg";